import {resolver} from './index';
import {Guest} from '../utils/types';

const ENDPOINTS = {
  all: (id = '') => `guests/${id ? `${id}/` : ``}`,
  one: (id: string, params = '') => `guests/${id}/${params}`,
};

function post(payload: any) {
  return resolver(ENDPOINTS.all(), {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

function deleteGuest(id: string) {
  return resolver(ENDPOINTS.all(id), {
    method: 'DELETE',
  });
}

function patch(
  id: string,
  payload: Partial<Omit<Guest, 'id'>> & {reservation_id?: string} = {},
) {
  return resolver(ENDPOINTS.all(id), {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export {ENDPOINTS, post, patch, deleteGuest};
